// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2Z_OF","header":"Messages_header__UW6Zs"};